import Header from '@buddieshr/components/header';
import MetaHeader from '@buddieshr/components/metaHeader';
import Footer from '@buddieshr/components/footer';
import { useRouter } from 'next/router';
import {
  LogoMarquee,
  Modular,
  NativeNotBot,
  Testimonials,
  FooterCTA,
} from '@buddieshr/components/landing/sections';
import {
  PLATFORMS,
  PlatformHero,
  PlatformInstall,
  PlatformFeatures,
  PlatformFAQ,
  PlatformSwitch,
} from '@buddieshr/components/microsoftTeams/sections';

export default function MicrosoftTeams({ refSource }) {
  const router = useRouter();
  const p = PLATFORMS.teams;
  return (
    <>
      <MetaHeader
        title="BuddiesHR for Microsoft Teams | The People Platform in Teams"
        description="Kudos, pulse surveys, birthdays, coffee chats and reviews, posted right inside Microsoft Teams. Native, not another portal. From $1/user/month, free under 10 employees."
        currentURL={`https://buddieshr.com/${
          router.locale === 'en' ? '' : router.locale
        }/microsoft-teams`}
        pageSlug="microsoft-teams"
        locale={router.locale}
      />
      <Header />
      <main className="bh">
        <PlatformHero p={p} />
        <LogoMarquee />
        <PlatformInstall p={p} />
        <PlatformFeatures p={p} />
        <Modular />
        <NativeNotBot platform="teams" />
        <Testimonials />
        <PlatformFAQ p={p} />
        <PlatformSwitch p={p} />
        <FooterCTA />
      </main>
      <Footer refSource={refSource} />
    </>
  );
}
